import React, { Component } from "react";
import classnames from "classnames";
import jsonp from "@alife/common-jsonp";

class Offer extends Component {
  constructor(opts) {
    super(opts);
    this.renderPrice = this.renderPrice.bind(this);
    this.renderZkPrice = this.renderZkPrice.bind(this);
    this.handleLinkClick = this.handleLinkClick.bind(this);
    this.dj = this.dj.bind(this);
    this.handleWWClick = this.handleWWClick.bind(this);
  }

  state = {
    // isYhprice: false
  };

  dj(eurl) {
    jsonp({
      callbackParamName: "callback",
      url: eurl,
    }).catch();
  };

  componentWillReceiveProps() {}

  renderOfferMiddle() {
    const { data } = this.props;
    const tags = data.attr.commonPositionLabels.offerMiddle;

    return (
      <div className="newTagGroup">
        {tags.map((tag) => (
          <div className="newTag">{tag.text}</div>
        ))}
      </div>
    );
  }

  renderRebuy() {
    const { data } = this.props;
    const rebuyRate = data.attr.information.rePurchaseRatePercentage;

    return <div className="rebuyRate">复购率{rebuyRate}</div>;
  }

  renderZkPrice() {
    let { discountPrice } = this.props.data;
    discountPrice = discountPrice || {};
    const { zkCat, zkPrice } = discountPrice;

    if (zkCat === "hp" && !!zkPrice) {
      return <span className="zkj zrColor">折扣价</span>;
    }
    if (!!zkPrice && zkCat !== "hp") {
      return <span className="zkj zrColor">折扣价</span>;
    } else {
      return <div />;
    }
  }
  //渲染阶梯价格
  renderPrice() {
    const { data } = this.props;
    let { discountPrice } = data;
    discountPrice = discountPrice || {};
    let { zkPrice } = discountPrice;
    const { price } = discountPrice;
    let { strPriceMoney } = data;
    let _html = "";
    try {
      if (zkPrice) {
        strPriceMoney = price;
        zkPrice = `${zkPrice}`;

        _html = (
          <a
            href={data.eurl}
            target="_blank"
            className="inline_block"
            rel="noreferrer"
          >
            <span className="showPricec">
              <div className="rmb zrColor">¥</div>
              <div className="price zrColor">{price}</div>
            </span>
          </a>
        );
      } else {
        _html = (
          <a
            href={data.eurl}
            target="_blank"
            className="inline_block"
            rel="noreferrer"
          >
            <div className="showPricec">
              <div className="rmb zrColor">¥</div>
              <div className="price zrColor">{strPriceMoney}</div>
            </div>
          </a>
        );
      }
    } catch (error) {
      _html = (
        <a
          href={data.eurl}
          target="_blank"
          className="inline_block"
          rel="noreferrer"
        >
          <div className="showPricec">
            <div className="rmb zrColor">¥</div>
            <div className="price zrColor">{strPriceMoney}</div>
          </div>
        </a>
      );
    }
    return _html;
  }

  companyInfo() {
    const { attr = {} } = this.props.data;

    if (
      attr &&
      attr.offerSource &&
      attr.offerSource.fromShili &&
      attr.tradeService &&
      attr.tradeService.tpYear
    ) {
      return (
        <a
          className="power-seller-tag identity-tag"
          href="//show.1688.com/shop/common/shilishangjia.html?__pageId__=104765&cms_id=104765"
          target="_blank"
          title="实力商家：更品质、更可靠、更贴心"
          rel="noreferrer"
        >
          {attr.tradeService.tpYear}年
        </a>
      );
    } else if (
      attr.tradeService &&
      attr.tradeService.tpMember &&
      attr.tradeService.tpYear
    ) {
      return (
        <a
          className="credit-tag identity-tag"
          href="https://shop255449x3k24k6.1688.com/page/creditdetail.htm?tracelog=p4p"
          target="_blank"
          title="阿里巴巴建议您优先选择诚信通会员"
          rel="noreferrer"
        >
          {attr.tradeService.tpYear}年
        </a>
      );
    }

    return null;
  }

  handleLinkClick() {
    const { data, index } = this.props;
    const isp4p = data.p4P || data.isP4P ? 1 : 0;
    const link = `${data.eurl}&idx=${index}`;

    if (!isp4p && goldlog && goldlog.record) {
      goldlog.record(
        "/btob.wxb.nature_offer_click",
        "CLK",
        `offerId=${data.offerid}`,
        "GET"
      );
    }

    window.open(link);
  }

  handleWWClick(e) {
    e.stopPropagation();
    const { data } = this.props;

    this.dj(data.eurl);
  }

  render() {
    const { data, mkc, index, idx } = this.props;
    let cbu_ad_sessionid = '';
    let cbu_ad_adgroup_id = '';
    const rebuyRate =
      data.attr.information && data.attr.information.rePurchaseRatePercentage;
    const tags =
      data.attr.commonPositionLabels &&
      data.attr.commonPositionLabels.offerMiddle;
    //兼容垃圾数据
    if (!data.attr.tradePrice) {
      return <div />;
    }

    const isp4p = data.p4P || data.isP4P ? 1 : 0;

    let { imgUrl, cpv } = data;
    if (imgUrl.indexOf("cbu01.alicdn.com") > -1) {
      if (imgUrl.indexOf(".gif") !== -1 && imgUrl.indexOf(".jpg") !== -1) {
        imgUrl = `${imgUrl.replace(/(.summ|.search|.jpg)/g, "")}?_=2020`;
      } else {
        imgUrl = `${imgUrl}?_=2020`;
      }
    }

    const gmv = data.attr.tradeQuantity.gmvValueFuzzify;

    const style = {
      marginRight: "11px",
      marginBottom: "11px",
      overflow: "hidden",
    };

    const alitalkidUTF8 = encodeURIComponent(data.loginId + "" || "");
    //添加打点参数
    let {trackInfo} = data;
    if(trackInfo && typeof trackInfo === 'string') {
      trackInfo = JSON.parse(trackInfo);
    } else if(!trackInfo) {
      trackInfo = {};
    }

    cbu_ad_sessionid = trackInfo.cbu_ad_sessionid;
    cbu_ad_adgroup_id = trackInfo.cbu_ad_adgroup_id;

    return (
      <div
        className={classnames({
          offer_item: true,
          new_offer_item: true,
          offer_with_zr_company: true,
          offer_exp: data.impressionEurl,
        })}
        style={style}
        data-jplus-exp-url={`${data.impressionEurl}&idx=${index}`}
        data-tracker="offer"
        data-aplus-report={`object_type@offer^object_id@${data.offerid}^_p_isad@${isp4p}^cbu_ad_sessionid@${cbu_ad_sessionid}^cbu_ad_adgroup_id@${cbu_ad_adgroup_id}`}
      >
        <div onClick={this.handleLinkClick} rel="noreferrer">
          <div className="img">
            {data.p4pShortVideoCoverUrl ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: `
              <video
                loop
                muted
                autoplay
                playsinline
                controls
                src="${data.p4pShortVideoCoverUrl}"
                class="video"
              />,
            `,
                }}
              />
            ) : (
              <img className="layLoad" src={imgUrl} />
            )}
          </div>
          <div
            dangerouslySetInnerHTML={{ __html: data.title }}
            className={classnames("title", {
              asZr: true,
            })}
            title={data.title.replace(/<[/]?font.*?>/g, "")}
          />
          {<div className="tagWrap">{this.renderOfferMiddle()}</div>}
          {
            <div className="priceLine" style={{ margin: "10px 0 7px" }}>
              <div className="showPricec">
                {this.renderPrice()}
                {
                  //this.renderZkPrice()
                }
              </div>
              {
                data.isPcSem && 
                <div className="wangwang" onClick={this.handleWWClick}>
                  <div className="common-wangwang-tag">
                    <span
                      className="J_WangWang"
                      data-nick={alitalkidUTF8}
                      data-encode="true"
                      data-icon="static"
                      data-from="cnalichn"
                      data-display="inline"
                    />
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    );
  }
}

export default Offer;
